import { useFormContext } from 'react-hook-form';

// 'Studio Nord GmbH' → 'studio-nord-gmbh', 'Bäckerei Müller' → 'baeckerei-mueller'.
export const toSlug = (name: string) =>
    name
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40)
        .replace(/-+$/, '');

// For a form with a name and its `slug`: while `hasAutoSlug` (a new one), the slug follows the name until it's edited
// by hand. Returns the name field's onChange.
export const useAutoSlug = (hasAutoSlug: boolean) => {
    const { getFieldState, setValue } = useFormContext<{ slug: string }>();
    return (name: string) => {
        if (hasAutoSlug && !getFieldState('slug').isDirty) setValue('slug', toSlug(name));
    };
};
